import {useEffect, useState} from "react";
import { valideLogin} from "./UserService";
import SimpleBackdrop from "../liveshows/background";


const UserValidToken = () => {

    const [loading, setLoading] = useState(false);

    useEffect(() => {
       async function validateToken() {
           const isValid = await valideLogin()
           if (isValid) {
               window.location.href = "/live";
           }
           else {
               window.location.href="/"
           }
           setLoading(true);
        }
        validateToken();
    }, []);

    return <>
        {
            loading? <SimpleBackdrop open={true}></SimpleBackdrop>
                : <></>

        }

    </>

}

export default UserValidToken;